export const MARK_ONBOARDING_COMPLETED = 'MARK_ONBOARDING_COMPLETED'
export const MARK_ONBOARDING_COMPLETED_RESPONSE = 'MARK_ONBOARDING_COMPLETED_RESPONSE'

export const GET_COMPLETED_ONBOARDINGS = 'GET_COMPLETED_ONBOARDINGS'
export const GET_COMPLETED_ONBOARDINGS_REQUEST = 'GET_COMPLETED_ONBOARDINGS_REQUEST'
export const GET_COMPLETED_ONBOARDINGS_RESPONSE = 'GET_COMPLETED_ONBOARDINGS_RESPONSE'
